// OpenTimeseriesFile.jsx

async function showFile(e, setData) {
  let RAINFALL = []
  e.preventDefault()

  const reader = new FileReader()

  reader.onload = async(e) => {
    const text = e?.target?.result
    // Translate the text to a swmmjs object.
    let lines = text.split(/\r\n|\r|\n/).filter(line => !line.includes(';') && line.length > 0 )

    RAINFALL = lines.map(v=>({
      DateTime: v.trim().split(/\s+/)[0] + ' ' + v.trim().split(/\s+/)[1] || '',
      Value: v.trim().split(/\s+/)[2] || '',
    }))

    setData(RAINFALL)
  }

  reader.readAsText(e.target.files[0])
}
 
export {showFile}